<div class="symptom-assessment-container">
  <div class="title-container">
    <div class="container">
      <svg class="icon" width="24" height="24" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.6028 9.4255C17.4867 4.96791 14.2881 2.72461 10.0001 2.72461C5.70995 2.72461 2.51352 4.96791 0.39745 9.42773C0.312574 9.60746 0.268555 9.80375 0.268555 10.0025C0.268555 10.2013 0.312574 10.3976 0.39745 10.5773C2.51352 15.0349 5.71218 17.2782 10.0001 17.2782C14.2903 17.2782 17.4867 15.0349 19.6028 10.5751C19.7747 10.2134 19.7747 9.79381 19.6028 9.4255ZM10.0001 15.671C6.39968 15.671 3.76352 13.8451 1.90415 10.0014C3.76352 6.15765 6.39968 4.33175 10.0001 4.33175C13.6006 4.33175 16.2367 6.15765 18.0961 10.0014C16.239 13.8451 13.6028 15.671 10.0001 15.671ZM9.91084 6.07282C7.7412 6.07282 5.98227 7.83175 5.98227 10.0014C5.98227 12.171 7.7412 13.93 9.91084 13.93C12.0805 13.93 13.8394 12.171 13.8394 10.0014C13.8394 7.83175 12.0805 6.07282 9.91084 6.07282ZM9.91084 12.5014C8.52915 12.5014 7.41084 11.3831 7.41084 10.0014C7.41084 8.6197 8.52915 7.5014 9.91084 7.5014C11.2925 7.5014 12.4108 8.6197 12.4108 10.0014C12.4108 11.3831 11.2925 12.5014 9.91084 12.5014Z"
          fill="currentColor"
        />
      </svg>
      <h2>{{ 'symptomAssessment.title' | translate }}</h2>
    </div>
    <p>{{ 'symptomAssessment.subtitle' | translate }}</p>
  </div>
  <div class="feel-container" nz-row>
    <div class="header-container" nz-col [nzSm]="12" [nzMd]="14" [nzLg]="14" [nzXl]="17">
      <h3>{{ 'symptomAssessment.how_do_you_feel' | translate }}</h3>
      <p>{{ 'symptomAssessment.verify_your_symptom' | translate }}</p>
    </div>
    <div class="button-container" nz-col [nzSm]="12" [nzMd]="10" [nzLg]="10" [nzXl]="7">
      <ds-button class="button-start" text="{{ 'symptomAssessment.start_valutation' | translate }}" [width]="'small'" (click)="startValutation()"></ds-button>
    </div>
  </div>
  <div class="carousel-container">
    <h3>{{ 'symptomAssessment.your_valutations' | translate }}</h3>
    <nz-divider></nz-divider>
    <div class="filters-container" nz-row>
      <!-- <div nz-col [nzSm]="24" [nzLg]="7" [nzXs]="24">
        <ds-select
          [placeholder]="'valutazioneSintomi.placeholder '| translate"
          [texts]="selectTexts"
          [values]="selectValues"
          [control]="selectForm?.get('options')">
        </ds-select>
        <!--<ds-search [control]="searchControl" placeholder="{{ 'symptomAssessment.search' | translate }}"> </ds-search>-->
      <!-- </div> -->
      <div nz-col [nzSm]="24" [nzLg]="24" [nzXl]="14" [nzXs]="24">
        <ds-datepicker
          [control]="selectForm?.get('startDate')"
          [endControl]="selectForm?.get('endDate')"
          placeholder="{{ 'symptomAssessment.start' | translate }}"
          secondPlaceholder="{{ 'symptomAssessment.end' | translate }}"
          middleText="{{ 'symptomAssessment.at' | translate }}"
          label="{{ 'symptomAssessment.filter_by' | translate }}"
        ></ds-datepicker>
      </div>
    </div>

    <div class="carousel-container">
      <div style="box-shadow: 0px 2px 8px 0px #00000018">
        @for (accordion of filteredAccordions; track accordion) {
          <div class="accordion-item">
            <div class="accordion-header">
              <div class="container-first">
                <div class="container-second">
                  <h4>{{ accordion.mainSymptom }}</h4>
                  <span>{{ accordion.consultDate }}</span>
                </div>
                <a [routerLink]="['symptom-assessment', accordion.individualId, accordion.consultDate]">
                  {{ 'symptomAssessment.see_details' | translate }}
                </a>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <nz-pagination (nzPageIndexChange)="changeAccordionsPage($event)" [(nzPageIndex)]="accordionsPageIndex" [nzPageSize]="5" [nzTotal]="totalAccordions"> </nz-pagination>
  </div>
</div>
